import dom from '../../utils/dom';
import DomEffects from '../../utils/DomEffects';

function init() {
  const $button = dom.find('.tn-listing-legend__button-toggle');

  if ($button) {
    const $labels = $button.querySelectorAll<HTMLElement>('.tn-listing-legend__btn-toggle-label');

    const $contents = dom.find('#tn-listing-legend-content') as HTMLDivElement;

    let isExpanded = $button.getAttribute('aria-expanded') === 'true';

    $button.addEventListener('click', () => {
      if (isExpanded) {
        DomEffects.collapse($contents);
      } else {
        DomEffects.expand($contents);
      }

      isExpanded = !isExpanded;

      [$button, $contents].forEach(($el) => {
        $el.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });

      $labels.forEach(($el) => {
        if ($el.style.display === 'none') {
          dom.toggle($el, true);
        } else {
          dom.toggle($el, false);
        }
      });
    });
  }
}

export default {
  init,
};
